import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default class FingerprintSaver {

    init() 
    {
        FingerprintJS.load().then(fp => fp.get()).then(result => {
            fetch('/set_device_id_cookie', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({deviceId: result.visitorId})
            });
        });
    }
}